(function (angular) {
    'use strict';

    angular.module('shared')
        .factory('signUpService', [
            '$http', "portalConfig", "$q", function ($http, portalConfig, $q) {
                var urlBase = portalConfig.urlBase;

                // urlBase = 'http://localhost:8002';
                var fac = {
                    createNewAccount: createNewAccount,
                    providePhoneNumber: providePhoneNumber,
                    provideVerifyCode: provideVerifyCode
                };
                return fac;

                function createNewAccount(data) {
                    ///membership/accounts/
                    return $http.post(urlBase + "/membership/accounts", data)
                        .then(createNewAccountComplete)
                        .catch(createNewAccountFailed);

                    function createNewAccountComplete(response) {
                        //token + refreshtoken
                        return response.data;
                    }

                    function createNewAccountFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }

                function providePhoneNumber(accountId, userId, data) {

                    return $http.post(urlBase + "/membership/accounts/" + accountId + "/users/" + userId + "/startVerify", data)
                        .then(createNewAccountComplete)
                        .catch(createNewAccountFailed);

                    function createNewAccountComplete(response) {
                        //verifyId
                        return response.data;
                    }

                    function createNewAccountFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }

                }
                function provideVerifyCode(accountId, userId, data) {
                    //data: verifyId + code
                    return $http.post(urlBase + "/membership/accounts/" + accountId + "/users/" + userId + "/completeVerify", data)
                        .then(createNewAccountComplete)
                        .catch(createNewAccountFailed);

                    function createNewAccountComplete(response) {
                        return response.data;
                    }

                    function createNewAccountFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }
            }
        ]);
})(window.angular);